export type ErrorSeverity = 'error' | 'warning';

export class AppError extends Error {
  readonly #type: string;
  readonly #severity: ErrorSeverity;
  readonly #uiMessage: string;

  constructor(
    type: string,
    message: string,
    uiMessage: string,
    cause: Error | null = null,
    severity: ErrorSeverity = 'error'
  ) {
    super(message, {
      cause
    });

    Object.setPrototypeOf(this, new.target.prototype);

    this.#type = type;
    this.#uiMessage = uiMessage;
    this.#severity = severity;
    this.name = 'AppError';
  }

  get type() {
    return this.#type;
  }

  get severity() {
    return this.#severity;
  }

  get uiMessage() {
    return this.#uiMessage;
  }
}
